export type StringBlock = { readonly id: string; readonly text: string; readonly reviewed: boolean };
export type ListBlock = { readonly id: string; readonly items: readonly string[]; readonly reviewed: boolean };

export const COPY = {
  chrome: {
    themeToggle: {
      id: "chrome.theme-toggle",
      text: "theme",
      reviewed: true,
    } satisfies StringBlock,
    attribution: {
      id: "chrome.attribution",
      text: "© OpenStreetMap contributors © CARTO",
      reviewed: true,
    } satisfies StringBlock,
  },
  landing: {
    heading: {
      id: "landing.heading",
      text: "enter access password",
      reviewed: true,
    } satisfies StringBlock,
    prompt: {
      id: "landing.prompt",
      text: "access password",
      reviewed: true,
    } satisfies StringBlock,
    submit: {
      id: "landing.submit",
      text: "open",
      reviewed: true,
    } satisfies StringBlock,
    verifying: {
      id: "landing.verifying",
      text: "checking",
      reviewed: true,
    } satisfies StringBlock,
    errors: {
      badPassword: {
        id: "landing.errors.bad_password",
        text: "that password does not open this share",
        reviewed: true,
      } satisfies StringBlock,
      rateLimited: {
        id: "landing.errors.rate_limited",
        text: "too many attempts, try again in {minutes} min",
        reviewed: true,
      } satisfies StringBlock,
      verificationUnavailable: {
        id: "landing.errors.verification_unavailable",
        text: "verification unavailable, refresh or try another network",
        reviewed: true,
      } satisfies StringBlock,
      expired: {
        id: "landing.errors.expired",
        text: "this share has expired",
        reviewed: true,
      } satisfies StringBlock,
      internal: {
        id: "landing.errors.internal",
        text: "something broke, refresh and try again",
        reviewed: true,
      } satisfies StringBlock,
    },
  },
  admin: {
    login: {
      title: {
        id: "admin.login.title",
        text: "admin sign in",
        reviewed: true,
      } satisfies StringBlock,
      email: {
        id: "admin.login.email",
        text: "email",
        reviewed: true,
      } satisfies StringBlock,
      password: {
        id: "admin.login.password",
        text: "password",
        reviewed: true,
      } satisfies StringBlock,
      totp: {
        id: "admin.login.totp",
        text: "6-digit code",
        reviewed: true,
      } satisfies StringBlock,
      submit: {
        id: "admin.login.submit",
        text: "sign in",
        reviewed: true,
      } satisfies StringBlock,
      error_generic: {
        id: "admin.login.error_generic",
        text: "sign in failed",
        reviewed: true,
      } satisfies StringBlock,
      enroll_heading: {
        id: "admin.login.enroll_heading",
        text: "set up 2-step sign in",
        reviewed: true,
      } satisfies StringBlock,
      enroll_hint: {
        id: "admin.login.enroll_hint",
        text: "scan the QR in an authenticator app, then enter the 6-digit code",
        reviewed: true,
      } satisfies StringBlock,
      enroll_manual_hint: {
        id: "admin.login.enroll_manual_hint",
        text: "if the QR will not scan, add the account manually with this key:",
        reviewed: true,
      } satisfies StringBlock,
    },
    stub: {
      id: "admin.stub",
      text: "signed in as {email} - admin surface ships in sprint 4",
      reviewed: true,
    } satisfies StringBlock,
  },
  expired: {
    heading: {
      id: "expired.heading",
      text: "this share has expired",
      reviewed: true,
    } satisfies StringBlock,
    body: {
      id: "expired.body",
      text: "contact your Bordeciel Labs contact for a fresh invite",
      reviewed: true,
    } satisfies StringBlock,
  },
  layers: {
    income: {
      id: "layers.income",
      reviewed: true,
      title: { text: "median household income" },
      description: { text: "after-tax income per household, 2021 census" },
      unit: { text: "CAD" },
      measureLabels: {
        "income.median_after_tax": { text: "median after tax" },
      },
    },
    age: {
      id: "layers.age",
      reviewed: true,
      title: { text: "age brackets" },
      description: { text: "share of population per age bracket, 2021 census" },
      unit: { text: "%" },
      measureLabels: {
        "age.under_35": { text: "under 35" },
        "age.35_64": { text: "35 to 64" },
        "age.65_plus": { text: "65 plus" },
      },
    },
    education: {
      id: "layers.education",
      reviewed: true,
      title: { text: "university degree" },
      description: { text: "share of population 25 plus with a university degree, 2021 census" },
      unit: { text: "%" },
      measureLabels: {
        "education.university_degree": { text: "degree share" },
      },
    },
    ethnicity: {
      id: "layers.ethnicity",
      reviewed: true,
      title: { text: "visible minority" },
      description: { text: "share of population identifying as visible minority, 2021 census" },
      unit: { text: "%" },
      measureLabels: {
        "ethnicity.visible_minority": { text: "vm share" },
      },
    },
    language: {
      id: "layers.language",
      reviewed: true,
      title: { text: "first official language" },
      description: { text: "share by first official language spoken, 2021 census" },
      unit: { text: "%" },
      measureLabels: {
        "language.french_only": { text: "french only" },
        "language.english_only": { text: "english only" },
        "language.bilingual_fr_en": { text: "bilingual fr/en" },
        "language.other": { text: "other" },
      },
    },
  },
} as const;
